import SectionHeader from "../common/SectionHeader";
import { acfList, acfText, resolveAcfLink } from "../../utils/landingAcf";
import { SECTION_CONTAINER } from "../../utils/layout";
import "../common/HeroSection.css";

function LandingQuality({ acf }) {
  const title = acfText(acf.quality_title);
  const description = acfText(acf.quality_description);
  const ctaText = acfText(acf.quality_cta_text);
  const ctaLink = resolveAcfLink(acf.quality_cta_link);
  const features = acfList(acf, "quality_feature_", 8);

  if (!title && !description && features.length === 0) return null;

  return (
    <section className="caf-section caf-section--elevated">
      <div className="caf-section__block caf-section__block--spaced">
        <div className={`${SECTION_CONTAINER} grid gap-8 lg:grid-cols-2 lg:items-start`}>
          <div>
            {title ? (
              <SectionHeader
                title={title}
                subtitle={description || undefined}
                showAccent
                centered={false}
                titleId="landing-quality-title"
              />
            ) : description ? (
              <p className="caf-row-body">{description}</p>
            ) : null}
            {ctaText && ctaLink ? (
              <a
                href={ctaLink.href}
                className="hero-btn hero-btn--primary mt-6 inline-flex max-w-sm"
                target={ctaLink.target}
                rel={ctaLink.target === "_blank" ? "noopener noreferrer" : undefined}
              >
                <span className="hero-btn__label">{ctaText}</span>
              </a>
            ) : null}
          </div>
          {features.length > 0 ? (
            <ul className="space-y-3" aria-labelledby={title ? "landing-quality-title" : undefined}>
              {features.map((feature) => (
                <li
                  key={feature}
                  className="rounded-lg border border-[rgba(0,164,79,0.18)] bg-white/80 px-4 py-3 text-sm leading-relaxed text-[var(--caf-text)]"
                >
                  {feature}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </div>
    </section>
  );
}

export default LandingQuality;
